import React from 'react';
import { headTableColumnType } from '../ModalTable/HeadTable';

interface IProps {
  quote: string;
  balances: boolean;
}

const useStatsTableData = ({ quote, balances }: IProps) => {
  // table memoized required fields
  const columns: headTableColumnType[] = React.useMemo(
    () => {
      const result: headTableColumnType[] = [
        {
          text: 'First Trade',
          id: 'firstTrade',
          type: 'none',
        },
        {
          text: 'Type',
          id: 'type',
          type: 'none',
        },
        {
          text: 'Price',
          id: 'priceBuyUSD',
          type: 'buy',
        },
        {
          text: `(${quote})`,
          id: 'priceBuy',
          type: 'buy',
        },
        {
          text: 'Price',
          id: 'priceSellUSD',
          type: 'sell',
        },
        {
          text: `(${quote})`,
          id: 'priceSell',
          type: 'sell',
        },
        {
          text: 'Total',
          id: 'total',
          type: 'none',
        }
      ];

      if (balances) {
        result.push({
          text: 'Balances',
          id: 'balances',
          type: 'none'
        } as headTableColumnType);
      }

      return result;
    }, [quote, balances]
  );

  return columns;
};

export { useStatsTableData };
